var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFlightNumber(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.9905 3.10287C19.2694 2.2657 19.2172 1.62042 18.8332 1.16677C18.3798 0.782983 17.7345 0.730841 16.8972 1.00942C16.06 1.28851 15.31 1.75939 14.6471 2.42217L12.5543 4.51534L3.85595 2.43541C3.7164 2.39175 3.58559 2.42662 3.46359 2.53997L1.78917 4.21444C1.69337 4.31048 1.65402 4.42819 1.67152 4.56771C1.69768 4.70742 1.77185 4.81193 1.89391 4.88176L8.53889 8.53155L5.15093 11.9198L2.6133 11.2266C2.59589 11.2178 2.56112 11.2135 2.50875 11.2135C2.3866 11.2135 2.28641 11.2526 2.20788 11.3312L0.952215 12.6C0.865028 12.7045 0.825856 12.8136 0.834561 12.9268C0.851879 13.0663 0.908553 13.1667 1.00458 13.2279L4.30082 15.7001L6.77298 18.9966C6.8515 19.0927 6.95619 19.1491 7.08699 19.1668H7.11315C7.2353 19.1668 7.3355 19.1277 7.41403 19.0493L8.66964 17.7936C8.78299 17.6713 8.8179 17.5362 8.77438 17.3879L8.08105 14.8501L11.469 11.4616L15.1186 18.1075C15.1709 18.2209 15.2624 18.2907 15.3933 18.3169C15.4193 18.3256 15.4499 18.3299 15.4849 18.3299C15.5893 18.3299 15.6723 18.3037 15.7332 18.2514L17.4079 16.9957C17.5559 16.8737 17.6082 16.7299 17.5648 16.5641L15.472 7.45933L17.578 5.35324C18.2406 4.69019 18.7114 3.94003 18.9905 3.10287Z",
    fill: "#AA8768"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlightNumber);
export default __webpack_public_path__ + "static/media/FlightNumber.358a5d42f708e0b99cf3c28fa319469c.svg";
export { ForwardRef as ReactComponent };